// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39XLW","delete":"styles_delete__3ffz_","update":"styles_update__31AC4","add":"styles_add__1Qr6O"};